<div class="composer-wrapper" [ngClass]="{ 'composer-disabled': processing }">
  <textarea
    #composerTextArea
    [(ngModel)]="messageText"
    [disabled]="!!disabled"
    class="composer-textarea"
    cdkTextareaAutosize
    [cdkAutosizeMinRows]="textAreaMinRows"
    [cdkAutosizeMaxRows]="textAreaMaxRows"
    [placeholder]="placeholder"
    (keydown.enter)="enterKeySendsMessage ? sendMessage($event) : null"
    [attr.enterkeyhint]="enterKeySendsMessage ? 'send' : null"
    [maxlength]="maxlength || null"
  ></textarea>

  <div class="controls-and-actions">
    <ng-content select="glxy-composer-actions"></ng-content>

    <div class="controls">
      <ng-container *ngIf="(chatSources?.length || 0) > 0">
        <ng-container *ngIf="chatSources.length === 1; else showChatSourceSelect">
          <div class="single-source-info">Send via {{ chatSourceLabel() }}</div>
        </ng-container>

        <ng-template #showChatSourceSelect>
          <div class="chat-source-select">
            <span class="send-via">Send via</span>
            <button mat-stroked-button class="source-item" [matMenuTriggerFor]="sourceMenu">
              <div class="menu-button-content">
                <div class="source-icon source-{{ currentChatSource?.id }}"></div>

                <div class="source-name" *ngIf="showFullSourceName">
                  {{ currentChatSource?.shortSourceName || currentChatSource?.sourceName }}
                </div>

                <mat-icon iconPositionEnd class="drop-down">arrow_drop_down</mat-icon>
              </div>
            </button>
          </div>
        </ng-template>
      </ng-container>
      <ng-content select="glxy-composer-beside-send"></ng-content>
      <ng-container *ngIf="{ processing } as state">
        <button
          mat-flat-button
          color="primary"
          (click)="sendMessage()"
          [disabled]="state.processing || disabled"
          [class.mat-custom-color]="customColor"
        >
          <glxy-button-loading-indicator [isLoading]="!!state.processing">Send</glxy-button-loading-indicator>
        </button>
      </ng-container>
    </div>
  </div>
</div>

<!-- Sources Menu -->
<mat-menu #sourceMenu="matMenu" xPosition="before" class="fit-content">
  <ng-container *ngFor="let item of chatSources">
    <button mat-menu-item class="source-item" (click)="changeChatSourceId(item.id, true)">
      <div class="menu-item-content">
        <div class="source-icon source-{{ item.id }}"></div>

        <div class="source-name-and-account">
          <div class="source-name">{{ item.sourceName }}</div>
          <ng-container *ngIf="item.account">
            <small class="account">{{ item.account }}</small>
          </ng-container>
        </div>
      </div>
    </button>
  </ng-container>
</mat-menu>
